console.log('Header.tsx: Starting imports...')
import React, { useEffect, useState } from 'react'
console.log('Header.tsx: Basic imports done...')
import { NavBar } from './NavBar'
import { MobileDrawer } from './MobileDrawer'
import { cn } from '@/lib/utils'
import { useIsMobile } from '@/hooks/use-mobile'
import tqayLogo from '@/assets/tqay-logo-new-main.png'
console.log('Header.tsx: All imports done, defining component...')

export function Header() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const isMobile = useIsMobile()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <>
      {/* Scroll Progress Bar - CSS only */}
      <div 
        className="hidden md:block fixed top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-primary via-blue-500 to-primary origin-left z-50"
        style={{ 
          transform: `scaleX(${typeof window !== 'undefined' ? window.scrollY / (document.documentElement.scrollHeight - window.innerHeight) : 0})`,
          transition: 'transform 0.1s linear'
        }}
      />
      
      <header
        className="fixed top-0 left-0 right-0 z-[1200] transition-smooth bg-white/95 backdrop-blur-md border-b shadow-elegant"
      >
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-24">
            {/* Logo */}
            <a
              href="/"
              className="flex items-center space-x-3 hover:opacity-90 transition-opacity"
              style={{ width: '150px', height: '64px' }}
            >
              <img 
                src={tqayLogo} 
                alt="TQAY Logo"
                width={150}
                height={60}
                loading="eager"
                style={{ width: '150px', height: '60px', display: 'block' }}
                className="object-contain"
              />
            </a>

            {/* Desktop Navigation - Absolutely Centered */}
            <div className="hidden lg:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <NavBar />
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden relative w-8 h-8 flex flex-col justify-center items-center group"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle mobile menu"
            >
              <span
                className={cn(
                  "w-6 h-0.5 bg-current transition-all duration-300",
                  isMobileMenuOpen ? "rotate-45 translate-y-0.5" : "rotate-0 translate-y-0"
                )}
              />
              <span
                className={cn(
                  "w-6 h-0.5 bg-current transition-all duration-300 mt-1",
                  isMobileMenuOpen ? "opacity-0" : "opacity-100"
                )}
              />
              <span
                className={cn(
                  "w-6 h-0.5 bg-current transition-all duration-300 mt-1",
                  isMobileMenuOpen ? "-rotate-45 -translate-y-1.5" : "rotate-0 translate-y-0"
                )}
              />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Drawer */}
      <MobileDrawer 
        isOpen={isMobileMenuOpen} 
        onClose={() => setIsMobileMenuOpen(false)} 
      />
    </>
  )
}

// Also export as default for compatibility
export default Header